import { PREDEFINED_LIBRARIES } from '../constants/Constants';

export const markPredefinedLibraries = (libraries) => {  
  const predefinedSet = new Set(PREDEFINED_LIBRARIES.map(name => name.toLowerCase().trim()));

  return libraries.map((lib) => ({
    ...lib,
    isPredefined: predefinedSet.has(lib.name.toLowerCase().trim())
  }));
};
